export const Spinner = () => {
    return <div className="spinner-border-lg" role="status">
        <span className="sr-only">Loading</span>
    </div>
}
